import { N as NcActionButton } from "./chunks/NcActionButton-D7uypboC.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-C3eUBbt4.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-Cbg5yktN.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-CMLDgnF_.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-B2bgbBHw.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-CX1MSord.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-BykT5Byh.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-7ziLICwJ.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-BDyBoXA1.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-DYdHKPv7.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-Dg-2s6bP.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import { N as NcAppNavigationNew } from "./chunks/NcAppNavigationNew-B8Ny1xKx.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-BHnL_502.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-DIO0S2TU.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-3jZKd9et.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-JB67n8yt.mjs";
import { N as NcAppSettingsSection } from "./chunks/NcAppSettingsSection-CsGyNFSh.mjs";
import { N as NcAppSettingsShortcutsSection } from "./chunks/NcAppSettingsShortcutsSection-BpUlnEbQ.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-B2F66PCc.mjs";
import { N as NcAppSidebarHeader } from "./chunks/NcAppSidebarHeader-CBE4tNYb.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAssistantButton } from "./chunks/NcAssistantButton-D2gOuok6.mjs";
import NcAssistantContent from "./Components/NcAssistantContent.mjs";
import { N as NcAssistantIcon } from "./chunks/NcAssistantIcon-CTTn1608.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-C1ty7wsG.mjs";
import { u } from "./chunks/NcAvatar-C1ty7wsG.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-DKfLn7BC.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-BPaEIFrD.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-BN_Nk5sm.mjs";
import { N as NcButton } from "./chunks/NcButton-DAGirW_B.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-BAjRm8PQ.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-75D50pZU.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-BwqjqV32.mjs";
import { N as NcContent } from "./chunks/NcContent-nvVwz9xO.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-oxV8oMlX.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-d_eqooRR.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-BiZ8QNOR.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-enXYuwj8.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-DoGsI2_6.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-D5yuDtSF.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-C_88_f6x.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import { N as NcFilePicker } from "./chunks/NcFilePicker-Dg6UqMN1.mjs";
import { N as NcFormBox } from "./chunks/NcFormBox-C38-8CH6.mjs";
import { N as NcFormBoxButton } from "./chunks/NcFormBoxButton-DFqqtbav.mjs";
import { N as NcFormBoxCopyButton } from "./chunks/NcFormBoxCopyButton-_KxKabAB.mjs";
import { N as NcFormBoxSwitch } from "./chunks/NcFormBoxSwitch-B34n4EwU.mjs";
import { N as NcFormGroup } from "./chunks/NcFormGroup-geUvdoIG.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderButton } from "./chunks/NcHeaderButton-BqjMDSal.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-BB2r8v-X.mjs";
import { N as NcHighlight } from "./chunks/index-CxTT94_h.mjs";
import { N as NcHotkey } from "./chunks/NcHotkey-B6KIqqii.mjs";
import { N as NcHotkeyList } from "./chunks/NcHotkeyList-BACQoMeA.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Bui9PhAS.mjs";
import { N as NcInputField } from "./chunks/NcInputField-Cym5GuvB.mjs";
import { N as NcListItem } from "./chunks/NcListItem-DFrhF-DU.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-DIecVacf.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-2woxTjbl.mjs";
import { N as NcPopover } from "./chunks/NcPopover-BaHX3QSG.mjs";
import NcProfileHoverCard from "./chunks/NcProfileHoverCard-DK5YkGF0.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-D7zYeXBH.mjs";
import { N as NcRadioGroup } from "./chunks/NcRadioGroup-D_7OAyQ4.mjs";
import { N as NcRadioGroupButton } from "./chunks/NcRadioGroupButton-CkpB4myv.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-BKygMHvP.mjs";
import { N as NcMentionBubble } from "./chunks/index-BCqXu_og.mjs";
import { r } from "./chunks/index-BCqXu_og.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-rJPX28V6.mjs";
import { N as NcRichText } from "./chunks/NcRichText-K2ZjNIbK.mjs";
import { N, i, r as r2, a } from "./chunks/customPickerElements-CYpmyl0b.mjs";
import { a as a2, g, b, c, s, d } from "./chunks/referencePickerModal-P_15xB7f.mjs";
import { N as NcSelect } from "./chunks/NcSelect-CxHfXvZV.mjs";
import "@nextcloud/axios";
import "@nextcloud/router";
import "./chunks/NcReferenceWidget-CMq5QVka.mjs";
import "./chunks/logger-D3RVzcfQ.mjs";
import { N as NcTextField } from "./chunks/NcTextField-CQp8XS4C.mjs";
import "@nextcloud/event-bus";
import { h, i as i2, r as r3, a as a3 } from "./chunks/widgets-XxirL-2f.mjs";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-U7AIamCl.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-BWTTPN2O.mjs";
import { N as NcSelectUsers } from "./chunks/NcSelectUsers-D2jOjPs4.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-Cc7cCwNm.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-D9qxzYDc.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-DzzNyHN_.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-T9totbme.mjs";
import { N as NcThemeProvider } from "./chunks/NcThemeProvider-BA_zMjAf.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-BfSjyBxq.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-Bd-PEfyK.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-gpl3yJFX.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { useFormatDateTime, useFormatRelativeTime, useFormatTime } from "./Composables/useFormatDateTime.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a4, e, g as g2, s as s2 } from "./chunks/emoji-Dtn2mDf7.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { usernameToColor } from "./Functions/usernameToColor.mjs";
import directive from "./Directives/Focus.mjs";
import directive$1 from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import "vue";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSettingsSectionShortcuts: NcAppSettingsShortcutsSection,
  NcAppSettingsShortcutsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcFilePicker,
  NcFormBox,
  NcFormBoxButton,
  NcFormBoxCopyButton,
  NcFormBoxSwitch,
  NcFormGroup,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcHotkey,
  NcHotkeyList,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProfileHoverCard,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSettingsShortcutsSection as NcAppSettingsSectionShortcuts,
  NcAppSettingsShortcutsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcFilePicker,
  NcFormBox,
  NcFormBoxButton,
  NcFormBoxCopyButton,
  NcFormBoxSwitch,
  NcFormGroup,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcHotkey,
  NcHotkeyList,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProfileHoverCard,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a2 as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a4 as emojiAddRecent,
  e as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b as getProvider,
  c as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  i as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i2 as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  r2 as registerCustomPickerElement,
  r3 as registerWidget,
  a as renderCustomPickerElement,
  a3 as renderWidget,
  r as richEditor,
  s as searchProvider,
  s2 as setCurrentSkinTone,
  d as sortProviders,
  spawnDialog,
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
